import { Button, Card, Grid, MenuItem, Select } from "@mui/material";
import { WBInput, WBSelect } from "components/_WBcomponents/WBInput";
import { couponTypeOptions, couponUsageOptions, regexNumber } from "helper/constant";
import React, { useEffect, useState } from "react";
import { createCoupon, getCoupon, updateCoupon } from "services/couponService";
import { getPropertiesId } from "services/propertiesService";
import { useParams } from 'react-router-dom';
import moment from "moment";
import { WBLabel } from "components/_WBcomponents/WBLabel";
import ReactQuill from "react-quill";
import { NumericFormat } from "react-number-format";
import { currencyFormat, marginFormat } from "helper/numberHelper";
import DeleteIcon from '@mui/icons-material/Delete';
import { addJastip } from "services/jastipService";
import { getEventList } from "services/eventService";
import { getProductList, getProductListv2 } from "services/productService";
import { addPO } from "services/poService";
import { getCustomerList } from "services/customerService";
import CustomerDropDown from "components/_WBcomponents/CustomerDropDown";
import AsyncSelect from "react-select/async";


function POForm ({
    loadData
}) {

    const [ form, setForm ] = useState({
        custName: "",
        custPhoneNumber: "",
        addressDetail: {
            streetName: ''
        },
        event: null,
        discount: 0,
        products: [],
        selectedProduct: null
        // {
        //     "_id": "677de8d0fd568e76a808b71e",
        //     "name": "24/25 Home Jersey Manchester United",
        //     "image": "https://www.adidas.co.id/media/catalog/product/j/f/jf1291_fr_torso_ecom.jpg",
        //     "price": 3500000,
        //     "totalPrice": 3500000,
        //     "qty": "1",
        //     "qtyType": "pcs",
        //     "product": "677de8d0fd568e76a808b71e"
        // }
    })
    const [ shoppingRequest, setShoppingRequest ] = useState({
        name: "",
        image: "",
        qty: "",
        qtyType: "",
        dp: "",
        price: "",
        buyPrice: "",
        totalPrice: "",
        notes: "",
        priceVariantList: [],
        selectedVariantPrice: null
    })
    const [ loading, setLoading ] = useState(false)
    const [ events, setEvents ] = useState([])
    const [ products, setProducts ] = useState([])
    const [ onAllowFilter, setOnAllowFilter ] = useState(false)
    const [ closeDropDown, setCloseDropDown ] = useState(false)

    // load properties Id
    const { id } = useParams();

    useEffect(() => {
        loadEvents()
    }, [])

    useEffect(() => {
        console.log(form, form.shoppingRequest)
    }, [form])

    useEffect(() => {
        loadProducts()
        setForm((prev) => ({
            ...prev,
            products: []
        }))
        setShoppingRequest({
            name: "",
            image: "",
            qty: "",
            qtyType: "",
            price: "",
            totalPrice: "",
        })
    }, [form.event])

    const onChange = (e) => {
        if (e.event) { setProducts([]) }
        setForm((prev) => ({
            ...prev,
            ...e
        }))
    }

    const loadEvents = async () => {
        let { data, error } = await getEventList({ type: 'po' })
        if (error) { console.log(error) }
        if (data) { 
            setEvents(data.map(v => {
                return {
                    value: v._id,
                    label: v.eventName
                }
            }))
        }
    }

    const loadProducts = async (e) => {
        if (form.event) {
            let { data, error } = await getProductListv2({ productName: e || '', event: (e && e.length > 3) ? '' : form.event ? form.event.value : '', isActive: true, page: 0, limit: 50 })
            if (error) { console.log(error) }
            if (data) { 
                let options = data.data.map(v => {
                    return {
                        value: v._id,
                        label: `${v.event._id.toString() != form.event.value.toString() ? `[${v.event.eventName}]` : ""} ${v.name}`,
                        data: v
                    }
                })
                setProducts(options)
                return options
            }
        }
    }

    const onChangeShopping = (e) => {
        setShoppingRequest(prev => ({
            ...prev,
            ...e
        }))
    }

    const addShoppingRequest = async () => {
        try {
            setShoppingRequest({
                name: "",
                image: "",
                qty: "",
                qtyType: "",
                price: "",
                buyPrice: "",
                dp:"",
                totalPrice: "",
                notes: "",
                priceVariantList: [],
                selectedVariantPrice: null
            })
            // check _id
            let similiar = false
            for (let i = 0; i < form.products.length; i ++) {
                if (form.products[i]._id == shoppingRequest._id) {
                    form.products[i] = shoppingRequest
                    similiar = true
                }
            }
            if (!similiar) { form.products.push(shoppingRequest) }
            onChange({
                products: [...form.products]
            })
        } catch (error) {
        }
    }

    const deleteShoppingRequest = async (index) => {
        try {
            form.products.splice(index, 1)
            onChange({
                products: form.products
            })
        } catch (error) {
        }
    }

    const savePO = async () => {
        setLoading(true)
        try {
            let { data, error } = await addPO({
                ...form,
                event: form.event ? form.event.value : ''
            })
            if (error) { throw error; }
            loadData()
            setLoading(false)
        } catch (error) {
            console.log(error)
            alert(error)
            setLoading(false)
        }
    }

    return (
        <Grid container xs={12} lg={12} p={2} pt={0} spacing={1} onClick={() => {
            setCloseDropDown(true)
        }}>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBSelect label={"PO Event"} inDialog={true} options={events} onChange={(e) => {
                        onChange({ event: e })
                    }} value={form.event}/>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12}>
                    <WBInput label={"Customer Name"} onChange={(e) => {
                        onChange({custName: e.currentTarget.value.toUpperCase()})
                    }} value={form.custName}/>
                </Grid>
            </Grid>
            <Grid item xs={12} lg={4} spacing={1}>
                <Grid item xs={12} onClick={(e) => {
                    e.stopPropagation()
                }}>
                    <WBInput label={"Phone Number"} onChange={(e) => {
                        if (!regexNumber(e.currentTarget.value)) { return }
                        onChange({custPhoneNumber: e.currentTarget.value})
                        setOnAllowFilter(true)
                    }} value={form.custPhoneNumber}/>
                    {
                        onAllowFilter &&
                        <CustomerDropDown
                            phoneNumber={form.custPhoneNumber} 
                            closeDropDown={closeDropDown}
                            setCloseDropDown={(e) => { setCloseDropDown(e) }}
                            onChange={(e) => { onChange(e) }}
                            setAllowFilter={(e) => { setOnAllowFilter(e) }}
                        />
                    }
                </Grid>
            </Grid>
            <Grid item xs={12} lg={12} spacing={1}>
                <Grid item xs={12}>
                    <WBInput type={"textarea"} label={"Customer Address"} onChange={(e) => {
                        onChange({addressDetail: {
                            streetName: e.currentTarget.value.toUpperCase()
                        }})
                    }} value={form.addressDetail.streetName}/>
                </Grid>
            </Grid>
            <Grid item container xs={12} lg={12} spacing={1}>
                <Grid item xs={12} mt={1}>
                    {/* <WBSelect label={"Request"} options={couponUsageOptions} onChange={(e) => {
                        onChange({price: e})
                    }} value={form.price}/> */}
                    <WBLabel style={{ fontWeight: 'bold', fontSize: 14 }}>Product Request</WBLabel>
                </Grid>
                <Grid item xs={12} md={6} lg={3.3}>
                    <WBLabel>Product Name</WBLabel>
                    <AsyncSelect async label={"Product Name"} inDialog={true} 
                        loadOptions={loadProducts}
                        defaultOptions={products} 
                    value={shoppingRequest ? {
                        value: shoppingRequest._id,
                        label: shoppingRequest.name
                    } : null} onChange={(e) => {
                        onChangeShopping({ 
                            _id: e.data._id,
                            name: e.data.name,
                            image: e.data.image,
                            qty: 1,
                            qtyType: e.data.qtyType,
                            price: e.data.price,
                            buyPrice: "",
                            priceVariantList: e.data.productVariantPrice,
                            selectedVariantPrice: null
                        })
                    }}/>
                </Grid>
                <Grid item xs={8} md={4.5} lg={1.5}>
                    <WBInput label={"Qty / Weight"} onChange={(e) => {
                        if (!regexNumber(e.currentTarget.value)) { return }
                        onChangeShopping({
                            qty: e.currentTarget.value,
                            totalPrice: e.currentTarget.value * shoppingRequest.price
                        })
                    }}  value={shoppingRequest.qty}/>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <WBSelect label={"Price Variant"} options={shoppingRequest.priceVariantList} inDialog={true} onChange={(e) => {
                        onChangeShopping({
                            price: e.price,
                            totalPrice: shoppingRequest.qty * e.price,
                            selectedVariantPrice: e
                        })
                    }}  value={shoppingRequest.selectedVariantPrice}/>
                </Grid>
                <Grid item container xs={12} gap={1}>
                    <Grid item xs={12} md={6} lg={2}>
                        <WBLabel style={{
                            color: "rgb(133, 133, 133)"
                        }}>Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                        <NumericFormat value={shoppingRequest.price}
                            isAllowed={(values) => {
                                const {floatValue} = values;
                                // if (form.couponType.value == "percentage") { 
                                //     if (floatValue > 100) { return false }
                                // }
                                return true
                            }}
                            onValueChange={(values) => {
                                const {formattedValue, value, floatValue} = values;
                                // do something with floatValue
                                onChangeShopping({ 
                                    price: value.replace(/^0+/, ''),
                                    totalPrice: value.replace(/^0+/, '') * shoppingRequest.qty
                                })
                            }}
                            // disabled={form._id}
                            decimalScale={0}
                            allowLeadingZeros={false}
                            allowedDecimalSeparators={false}
                            allowNegative={false}
                            thousandSeparator
                            customInput={WBInput}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={2}>
                        <WBLabel style={{
                            color: "rgb(133, 133, 133)"
                        }}>Buy Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                        <NumericFormat value={shoppingRequest.buyPrice}
                            onValueChange={(values) => {
                                const { value } = values;
                                onChangeShopping({ buyPrice: value.replace(/^0+/, '') })
                            }}
                            decimalScale={0}
                            allowLeadingZeros={false}
                            allowedDecimalSeparators={false}
                            allowNegative={false}
                            thousandSeparator
                            customInput={WBInput}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={2}>
                        <WBLabel style={{
                            color: "rgb(133, 133, 133)"
                        }}>DP</WBLabel>
                        <NumericFormat value={shoppingRequest.dp}
                            isAllowed={(values) => {
                                const {floatValue} = values;
                                // if (form.couponType.value == "percentage") { 
                                //     if (floatValue > 100) { return false }
                                // }
                                return true
                            }}
                            onValueChange={(values) => {
                                const {formattedValue, value, floatValue} = values;
                                // do something with floatValue
                                onChangeShopping({ 
                                    dp: value.replace(/^0+/, '')
                                })
                            }}
                            // disabled={form._id}
                            decimalScale={0}
                            allowLeadingZeros={false}
                            allowedDecimalSeparators={false}
                            allowNegative={false}
                            thousandSeparator
                            customInput={WBInput}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <WBLabel style={{
                            color: "rgb(133, 133, 133)"
                        }}>Total Price</WBLabel>
                        <NumericFormat value={shoppingRequest.totalPrice}
                            isAllowed={(values) => {
                                const {floatValue} = values;
                                // if (form.couponType.value == "percentage") { 
                                //     if (floatValue > 100) { return false }
                                // }
                                return true
                            }}
                            onValueChange={(values) => {
                                const {formattedValue, value, floatValue} = values;
                                // do something with floatValue
                                onChangeShopping({ totalPrice: value.replace(/^0+/, '') })
                            }}
                            // disabled={form._id}
                            decimalScale={0}
                            allowLeadingZeros={false}
                            allowedDecimalSeparators={false}
                            allowNegative={false}
                            thousandSeparator
                            customInput={WBInput}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <WBInput type={"textarea"} label={"Notes"} onChange={(e) => {            
                        onChangeShopping({ notes: e.currentTarget.value })
                    }} value={shoppingRequest.notes}/>
                </Grid>
                <Grid item xs={12} lg={12} mt={1} textAlign={"right"}>
                    <div style={{marginTop: 12}}/>
                    <Button variant="contained" 
                    disabled={
                        !shoppingRequest.name ||
                        !shoppingRequest.qty || !shoppingRequest.price
                    }
                    onClick={() => {
                        addShoppingRequest()
                    }}>Add</Button>
                </Grid>
            </Grid>
            <Grid container item spacing={1} mt={1}>
                <Grid item xs={12} mt={1}>
                    {/* <WBSelect label={"Request"} options={couponUsageOptions} onChange={(e) => {
                        onChange({price: e})
                    }} value={form.price}/> */}
                    <WBLabel style={{ fontWeight: 'bold', fontSize: 14 }}>Product Request List : </WBLabel>
                </Grid>
                {
                    form.products.map((value, index) => {
                        return (
                            <Grid item lg={6} md={6} xs={12}>
                                <Card>
                                    <Grid container p={2}>
                                        <Grid item xs={11}>
                                            <Grid>
                                                <img src={value.image} width={100} height={100}/>
                                            </Grid>
                                            <Grid>
                                                <WBLabel bold>{value.name}</WBLabel>
                                            </Grid>
                                            <Grid>
                                                <WBLabel>{currencyFormat(value.price)} x {value.qty}</WBLabel>
                                            </Grid>
                                            <Grid container item gap={1}>
                                                <WBLabel bold>{currencyFormat(value.totalPrice)}</WBLabel>
                                                {value.dp && <WBLabel bold subtitle>(DP : {currencyFormat(value.dp)})</WBLabel>}
                                            </Grid>
                                            {
                                                value.buyPrice &&
                                                <Grid>
                                                    <WBLabel subtitle>Buy {currencyFormat(value.buyPrice)} x {value.qty} · Margin {marginFormat(value.totalPrice - value.buyPrice * value.qty)}</WBLabel>
                                                </Grid>
                                            }
                                            <Grid>
                                                <WBLabel bold subtitle>Notes:</WBLabel>
                                                <WBLabel>{value.notes || "-"}</WBLabel>
                                            </Grid>
                                        </Grid>
                                        <Grid textAlign={"right"} item xs={1}>
                                            <div style={{
                                                cursor: 'pointer'
                                            }} onClick={() => {
                                                deleteShoppingRequest(index)
                                            }}>
                                                <DeleteIcon color="black" />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        )
                    })
                }
            </Grid>
            <Grid item xs={12} mt={1} textAlign={"right"}>
                <Button variant="contained" 
                disabled={
                    !form.custName ||
                    // !form.custPhoneNumber ||
                    !form.products || (form.products && form.products.length <= 0) ||
                    loading
                }
                onClick={() => {
                    savePO()
                }}>Save</Button>
            </Grid>
        </Grid>
    )
}

export default POForm